// src/app/layouts/MainLayout.tsx
import { Outlet } from 'react-router-dom';
import { Header } from '@/widgets/Header/Header';
import { Footer } from '@/widgets/Footer/Footer';
import {ScrollToTop} from "@/features/ScrollToTop/ScrollToTop";

export const MainLayout = () => {
    return (
        <>
            <ScrollToTop />
            <Header />
            <main>
                <Outlet />
            </main>
            <Footer />
        </>
    );
};
